import angular from 'angular';
import creditworthinessMobileHeaderComponent from './creditworthinessMobileHeader.component';

let creditworthinessMobileHeaderModule = angular.module('creditworthinessMobileHeader', [
])

.component('creditworthinessMobileHeader', creditworthinessMobileHeaderComponent)

.name;

export default creditworthinessMobileHeaderModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessMobileHeader/creditworthinessMobileHeader.js